import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const PayPalCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="bg-yellow-50 border-b text-center">
          <XCircle className="mx-auto text-yellow-600 mb-4" size={64} />
          <CardTitle className="text-yellow-700">Zahlung abgebrochen</CardTitle>
        </CardHeader>
        <CardContent className="p-6 text-center space-y-6">
          <p className="text-gray-600">
            Die PayPal-Zahlung wurde abgebrochen. Ihre Bestellung wurde nicht abgeschlossen.
          </p>
          
          <p className="text-sm text-gray-500">
            Falls Sie Probleme mit der Zahlung haben, können Sie auch per SEPA-Überweisung (Vorkasse) bezahlen.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={() => navigate('/warenkorb')}
              variant="outline"
              className="flex-1"
            >
              <ArrowLeft className="mr-2" size={18} />
              Zum Warenkorb
            </Button>
            
            <Button 
              onClick={() => navigate('/checkout')}
              className="flex-1 bg-red-600 hover:bg-red-700"
            >
              Erneut versuchen
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PayPalCancel;
